import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React from "react";
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { getProjectStepImg, getProjectStepName } from 'utils/projects';

class Profile extends React.Component {

    state = {
        projects: [],
        canSave: true
    }

    componentWillMount = () => {

        let projects = this.props.app_projects;
        //only get projects that have to do with this user
        projects = projects.filter(p => this.props.viewing_user.projects_assigned.includes(p._id))
        
        this.setState({projects})

    }
    
    render() {

        return (
            <>

            <Container>     

                <Helmet>
                    <title>Settings</title>
                    <meta name="description" content="Settings" />
                </Helmet>

                {this.state.alert}

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers" 
                    title={<span>Dashboard</span>} breadcrumb_1="My Projects"  
                />

                <Row >

                    {this.state.projects.length ? this.state.projects.map(p => (
                        <Col key={p._id} xl={4}>
                            <Link to={"/developers/projects/" + p._id}>
                                <Card className="mb-4">
                                    <CardHeader className="text-center">
                                        <h2 className="mb-0">{p.name}</h2>
                                        <h5 className="text-muted">
                                            Status: {getProjectStepName(p.step)}
                                        </h5>

                                    </CardHeader>
                                    <CardBody>
                                        <img src={getProjectStepImg(p.step)} alt="..." className="w-100" />
                                    </CardBody>
                                </Card>
                            </Link>
                        </Col>
                    )): (
                        <Col xs={12}>
                                <Card>
                                    <CardBody>
                                        <h2>Your account does not have any projects assigned to it yet.</h2>
                                    </CardBody>
                                </Card>
                        </Col>
                    )}
                </Row>

            </Container>
            </>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
      app_projects: state.projects.app_projects,
  
    };
};
  
export default connect(mapStateToProps, '')(Profile);